(function () {
  const initHeroSliders = () => {
    if (typeof Swiper === 'undefined') {
      return;
    }

    document.querySelectorAll('[data-hero-slider]').forEach((root) => {
      if (root.dataset.heroInitialized === 'true') {
        return;
      }

      const mainElement = root.querySelector('[data-hero-main]');
      const thumbsElement = root.querySelector('[data-hero-thumbs]');
      const prevButton = root.querySelector('[data-hero-prev]');
      const nextButton = root.querySelector('[data-hero-next]');
      const paginationElement = root.querySelector('[data-hero-pagination]');

      if (!mainElement) {
        return;
      }

      let thumbsSwiper = null;

      if (thumbsElement) {
        thumbsSwiper = new Swiper(thumbsElement, {
          spaceBetween: 8,
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          centerInsufficientSlides: true,
        });
      }

      const swiperOptions = {
        speed: 450,
        slidesPerView: 1,
        spaceBetween: 0,
        resistanceRatio: 0,
        grabCursor: true,
      };

      if (prevButton && nextButton) {
        swiperOptions.navigation = {
          prevEl: prevButton,
          nextEl: nextButton,
        };
      }

      if (paginationElement) {
        swiperOptions.pagination = {
          el: paginationElement,
          clickable: true,
        };
      }

      if (thumbsSwiper) {
        swiperOptions.thumbs = {
          swiper: thumbsSwiper,
        };
      }

      const autoplayEnabled = root.dataset.autoplay === 'true';
      const autoplayDelay = Number(root.dataset.autoplayDelay) || 5000;
      const pauseOnHover = root.dataset.autoplayPauseOnHover === 'true';

      if (autoplayEnabled) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: pauseOnHover,
        };
      }

      const mainSwiper = new Swiper(mainElement, swiperOptions);

      if (paginationElement) {
        const resetHeroPagination = () => {
          paginationElement.style.setProperty('transform', 'none', 'important');
          paginationElement.style.setProperty('left', '0', 'important');
          paginationElement.style.setProperty('width', '100%', 'important');
        };

        resetHeroPagination();
        mainSwiper.on('slideChange', resetHeroPagination);
        mainSwiper.on('paginationUpdate', resetHeroPagination);
        mainSwiper.on('resize', resetHeroPagination);
      }

      root.dataset.heroInitialized = 'true';
    });
  };

  const initFeaturedPicks = () => {
    if (typeof Swiper === 'undefined') {
      return;
    }

    document.querySelectorAll('[data-featured-picks]').forEach((root) => {
      if (root.dataset.featuredPicksInitialized === 'true') {
        return;
      }

      const mainElement = root.querySelector('[data-featured-picks-main]');
      const prevButton = root.querySelector('[data-featured-picks-prev]');
      const nextButton = root.querySelector('[data-featured-picks-next]');

      if (!mainElement) {
        return;
      }

      const swiperOptions = {
        speed: 450,
        spaceBetween: 12,
        slidesPerView: 2,
        grabCursor: true,
        breakpoints: {
          1200: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        },
      };

      if (prevButton && nextButton) {
        swiperOptions.navigation = {
          prevEl: prevButton,
          nextEl: nextButton,
        };
      }

      new Swiper(mainElement, swiperOptions);

      root.dataset.featuredPicksInitialized = 'true';
    });
  };

  const pauseVideosInSwiper = (swiper) => {
    swiper.slides.forEach((slide) => {
      slide.querySelectorAll('video').forEach((video) => {
        video.pause();
      });
    });
  };

  const playActiveSlideVideos = (swiper) => {
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (!activeSlide) {
      return;
    }

    activeSlide.querySelectorAll('video').forEach((video) => {
      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  };

  const initVideoShowcases = () => {
    if (typeof Swiper === 'undefined') {
      return;
    }

    document.querySelectorAll('[data-video-showcase]').forEach((root) => {
      if (root.dataset.videoShowcaseInitialized === 'true') {
        return;
      }

      const mainElement = root.querySelector('[data-video-showcase-main]');
      const prevButton = root.querySelector('[data-video-showcase-prev]');
      const nextButton = root.querySelector('[data-video-showcase-next]');

      if (!mainElement) {
        return;
      }

      const swiperOptions = {
        speed: 450,
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        on: {
          init: (swiper) => {
            playActiveSlideVideos(swiper);
          },
          slideChange: (swiper) => {
            pauseVideosInSwiper(swiper);
            playActiveSlideVideos(swiper);
          },
        },
      };

      if (prevButton && nextButton) {
        swiperOptions.navigation = {
          prevEl: prevButton,
          nextEl: nextButton,
        };
      }

      new Swiper(mainElement, swiperOptions);

      root.dataset.videoShowcaseInitialized = 'true';
    });
  };

  const initThemeSections = () => {
    initHeroSliders();
    initFeaturedPicks();
    initVideoShowcases();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThemeSections);
  } else {
    initThemeSections();
  }

  document.addEventListener('shopify:section:load', initThemeSections);
})();
